import React, { useEffect, useRef, useState } from 'react';
import './Stats.css';

const Stats: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const statsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: '0px'
      }
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => {
      if (statsRef.current) {
        observer.unobserve(statsRef.current);
      }
    };
  }, []);

  const stats = [
    { number: '190+', label: 'HOMES', icon: '🏠', image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80' },
    { number: '65+', label: 'APARTMENTS', icon: '🏢', image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80' },
    { number: '27+', label: 'OFFICES', icon: '🏛️', image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80' },
    { number: '4+', label: 'HOTELS', icon: '🏨', image: 'https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80' },
  ];

  return (
    <section className="stats" ref={statsRef}>
      <div className="stats-container">
        {stats.map((stat, index) => (
          <div 
            key={index} 
            className={`stat-item ${isVisible ? 'animate-in' : 'animate-out'}`}
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <div className="stat-image">
              <img src={stat.image} alt={stat.label} />
            </div>
            <div className="stat-content">
              <h3 className="stat-number">{stat.number}</h3>
              <p className="stat-label">{stat.label}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
